// =======================================
// fade in
// =======================================
document.addEventListener('DOMContentLoaded', () => {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined')
    return;

  gsap.registerPlugin(ScrollTrigger);

  const timeDelay = 250; // 時間差のタイミング(ミリ秒)
  const maxItemNumber = 3; // 時間差で発火させる最大要素数

  for (let i = 0; i < maxItemNumber; i++) {
    const fadeInItems = document.querySelectorAll(
      `.c-animated__fadeIn.--delay${i}:not(.js-hero-load-target)`,
    );
    fadeInFunction(fadeInItems, i * timeDelay);
  }

  function fadeInFunction(fadeInItems, timeout) {
    fadeInItems.forEach((item) => {
      ScrollTrigger.create({
        trigger: item,
        start: 'top 70%',
        onEnter: () => {
          setTimeout(() => {
            item.classList.add('js-show');
          }, timeout);
        },
      });
    });
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const heroTargets = Array.from(
    document.querySelectorAll('.js-hero-load-target'),
  )
    .sort(
      (a, b) =>
        Number(a.dataset.heroOrder ?? 0) - Number(b.dataset.heroOrder ?? 0),
    )
    .filter(Boolean);

  if (!heroTargets.length) return;

  // 画面表示直後から開始（1行目は待ちなし、その後は順番に少しずつ遅延）
  const LINE1_MS = 0;
  const LINE2_MS = 600;
  const BUBBLE_MS = 1200;
  const IMAGE_CAPTION_MS = 1700;

  const heroDelayByOrder = (order) => {
    switch (Number(order)) {
      case 0:
        return LINE1_MS;
      case 1:
        return LINE2_MS;
      case 2:
        return BUBBLE_MS;
      case 3:
        return IMAGE_CAPTION_MS;
      default:
        return 0;
    }
  };

  const runHeroAnimation = () => {
    const reduceMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)',
    ).matches;

    heroTargets.forEach((item) => {
      const order = Number(item.dataset.heroOrder ?? 0);
      setTimeout(() => {
        item.classList.add('js-show');
        if (
          !reduceMotion &&
          item.classList.contains('p-frontHero__bubbleWrap')
        ) {
          item.classList.add('js-heroBubbleBounce');
        }
      }, heroDelayByOrder(order));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runHeroAnimation, {
      once: true,
    });
  } else {
    runHeroAnimation();
  }
});
